import {useState} from 'react'

const DefaultControl = ({value}) => {
    const [message, Message] = useState(value ?? "قم بتسجيل الدخول للمتابعة")
    return (
        <div className="Title" style={{width:'100%', margin:'12rem auto'}}>
        <h1>moshaf.akademy.ma</h1>
        <h2>{message}</h2>
        <h3>Log In to continue</h3>
        </div>
    )
}

const toTime = (seconds) => { 
    const hrs = Math.floor(seconds / 3600); 
    const mins = Math.floor((seconds % 3600) / 60); 
    const secs = seconds % 60; 
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`; 
};

const Duration = (secondes) => {
    if(secondes>=60) {
        let h = Math.floor(secondes/3600)
        let m = Math.floor((secondes-h*3600)/60)
    
        return h.toString().padStart(2,'0')+":"+m.toString().padStart(2,'0') ;
    }
    else
        return "0:"+secondes.toString().padStart(2,'0')+"s" ;
}

export {DefaultControl, toTime, Duration}
